import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import zhCN from 'element-ui/lib/locale/lang/zh-CN'
import en from 'element-ui/lib/locale/lang/en'
import zhCNMessages from './locales/zh-CN'
import enMessages from './locales/en'

Vue.use(VueI18n)

const LOCALE_KEY = 'locale'

export function getSavedLocale() {
  const saved = localStorage.getItem(LOCALE_KEY)
  if (saved === 'zh-CN' || saved === 'en') return saved
  return 'zh-CN'
}

const i18n = new VueI18n({
  locale: getSavedLocale(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCNMessages,
    en: enMessages
  }
})

export function applyElementLocale(locale) {
  ElementLocale.use(locale === 'en' ? en : zhCN)
}

export function setLocale(locale) {
  i18n.locale = locale
  localStorage.setItem(LOCALE_KEY, locale)
  applyElementLocale(locale)
  document.documentElement.setAttribute('lang', locale)
}

export const LOCALE_KEY_NAME = LOCALE_KEY
export default i18n